import type { ReactNode } from 'react';

interface DataUnavailableProps {
  icon: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
}

export function DataUnavailable({
  icon,
  title,
  subtitle,
}: DataUnavailableProps) {
  return (
    <div className="mt-md flex w-full flex-col items-center justify-center gap-lg rounded-sm border border-dashed py-5xl bg-level-01 border-emphasis-subtle">
      <span className="flex shrink-0 items-center justify-center">{icon}</span>
      <div className="flex w-full flex-col items-center justify-center gap-sm text-center">
        <h2 className="text-headline-md font-semibold text-default">{title}</h2>
        {subtitle ? (
          <div className="text-body-md font-normal text-subtle">{subtitle}</div>
        ) : null}
      </div>
    </div>
  );
}

DataUnavailable.displayName = 'DataUnavailable';
